<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-content">

    <div class="cp-header">
      <div class="cp-label">
        {{ 'reset_password' | translate }}
      </div>
      <div class="cp-button" (click)="close()">
        <img src="assets/img/ic-close.png"/>
      </div>
    </div>

    @if (!success()) {
    <form [formGroup]="resetForm" (ngSubmit)="resetPassword()">
      <div class="cp-field cp-p-24">
        <label class="cp-label">
          {{ 'insert_email_address' | translate }}
        </label>
        <div class="cp-control">
          <input class="cp-input" type="email" formControlName="email">
        </div>

        @if (error()) {
          <div class="cp-error cp-m-top-8">
            {{ error() }}
          </div>
        }
      </div>

      <div class="cp-footer">
        <button class="coupon-button" [disabled]="resetForm.invalid">
          {{ 'reset' | translate }}
        </button>
      </div>
    </form>
    }
    @else {
    <div class="cp-p-24 cp-success">
      {{ 'message_password_reset_success' | translate }}
    </div>
    }

  </div>
</div>
